<template>
  <div class="completion-percent mr-2 d-flex align-items-center">
    <v-ons-progress-circular :value="percent" secondary-value="100">
      <div
        v-if="percent === 100"
        data-cy="completion-check"
        class="completion-percent__tick"
      >
        <v-icon icon="done_all" />
      </div>
    </v-ons-progress-circular>
    <span class="completion-percent__text">{{ percentComplete }}%</span>
  </div>
</template>

<script>
export default {
  props: {
    percentComplete: { type: [Number], required: true }
  },

  data() {
    return {
      percent: 0
    }
  },

  watch: {
    percentComplete: {
      immediate: true,
      handler() {
        if (this.percentComplete !== 100) {
          // Triggers a fill animation
          setTimeout(() => {
            this.percent = this.percentComplete
          }, 150)
        } else {
          this.percent = this.percentComplete
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.completion-percent {
  ons-progress-circular {
    position: relative;
  }

  .progress-circular--material__primary {
    stroke-width: 16%;
    stroke: var(--brand-color-hex);
    stroke-linecap: round;
  }

  .progress-circular--material__secondary {
    stroke-width: 10%;
    stroke: $color-ui--grey-20;
  }
}

.completion-percent__text {
  font-size: $font-size--small;
  font-weight: $font-weight--semi-bold;
  margin-left: $size--2;
}

.completion-percent__tick {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--brand-color-hex);
  color: $color-ui--white;
  border-radius: 50px;

  .v-icon {
    font-size: 1.25rem;
    opacity: 0;
    animation: bounce-in 0.75s forwards;
    animation-delay: 0.24s;
  }
}
</style>
